import { useState, useEffect, createContext, useContext } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const FeatureFlagContext = createContext({});

/**
 * Provider that fetches active feature flags once and provides them to the app.
 * Wrap your App with <FeatureFlagProvider> to use the useFeatureFlag hook.
 */
export const FeatureFlagProvider = ({ children }) => {
  const [flags, setFlags] = useState({});

  useEffect(() => {
    axios.get(`${API}/api/feature-flags/active`)
      .then(res => setFlags(res.data || {}))
      .catch(() => {});
  }, []);

  return (
    <FeatureFlagContext.Provider value={flags}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

/**
 * Hook to check a feature flag.
 * Returns the variant value if enabled, or the fallback.
 * 
 * Usage:
 *   const pricingVariant = useFeatureFlag('pricing_page_v2', 'control');
 *   if (pricingVariant === 'variant_a') { ... }
 * 
 *   const isEnabled = useFeatureFlag('new_search', false);
 *   if (isEnabled) { ... }
 */
export const useFeatureFlag = (key, fallback = false) => {
  const flags = useContext(FeatureFlagContext);
  return key in flags ? flags[key] : fallback;
};
